// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"218":"6b2758fcb59cadb40dd9","895":"12d43385ce97df0bca05"}[chunkId] + ".js";
};